export default function formatNotificationBadge(badge) {
  if (typeof badge !== 'number') {
    return badge;
  }
  return badge > 99 ? '99+' : badge;
}
